document.addEventListener('DOMContentLoaded', function () {
  initMegaMenu();
  observeDrawerOpen();

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initMegaMenu, 250);
  });
});

function observeDrawerOpen() {
  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (!drawerDetails) return;

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.attributeName === 'open' &&
        drawerDetails.hasAttribute('open') &&
        window.innerWidth <= 768
      ) {
        setTimeout(function () {
          initMegaMenu();
        }, 350);
      }
    });
  });

  observer.observe(drawerDetails, { attributes: true });
}

function initMegaMenu() {
  const isMobile = window.innerWidth <= 768;

  // #menu-mobile ES el nav.mega-menu — son el mismo elemento
  const megaMenu = document.querySelector('#menu-mobile');
  if (!megaMenu) return;

  const menuItems = megaMenu.querySelectorAll('.menu-item.has-dropdown');

  if (isMobile) {
    // Mover cada .mega-dropdown fuera del .menu-item y ponerlo
    // como hijo directo de megaMenu (debajo del .menu-principal)
    menuItems.forEach((item, index) => {
      const dropdown = item.querySelector('.mega-dropdown');
      if (!dropdown) return;

      dropdown.dataset.menuItemIndex = index;

      if (dropdown.parentElement === item) {
        megaMenu.appendChild(dropdown);
      }
    });

    // Asignar clicks a los tabs
    menuItems.forEach((item, index) => {
      const link = item.querySelector('.menu-link');
      if (!link) return;

      const newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);

      newLink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Desactivar todos
        menuItems.forEach(otherItem => otherItem.classList.remove('active'));
        megaMenu.querySelectorAll('.mega-dropdown').forEach(d => {
          d.classList.remove('active');
          d.style.display = 'none';
        });

        // Activar el clickeado
        item.classList.add('active');
        const activeDropdown = megaMenu.querySelector(`.mega-dropdown[data-menu-item-index="${index}"]`);
        if (activeDropdown) {
          activeDropdown.style.display = 'block';
          activeDropdown.classList.add('active');
        }
      });

      // Activar primer tab por defecto
      if (index === 0) {
        item.classList.add('active');
        requestAnimationFrame(() => {
          const firstDropdown = megaMenu.querySelector('.mega-dropdown[data-menu-item-index="0"]');
          if (firstDropdown) {
            firstDropdown.style.display = 'block';
            firstDropdown.classList.add('active');
          }
        });
      }
    });

  } else {
    // Desktop: devolver dropdowns a sus menu-items originales
    megaMenu.querySelectorAll('.mega-dropdown[data-menu-item-index]').forEach(dropdown => {
      const idx = parseInt(dropdown.dataset.menuItemIndex);
      const originalItem = menuItems[idx];
      if (originalItem && dropdown.parentElement !== originalItem) {
        dropdown.style.display = '';
        originalItem.appendChild(dropdown);
      }
    });

    menuItems.forEach(item => item.classList.remove('active'));
  }
}

/* Resetear al primer tab si el usuario scrollea mucho */
let lastScrollTop = 0;
window.addEventListener('scroll', function () {
  if (window.innerWidth > 768) return;

  const st = window.pageYOffset || document.documentElement.scrollTop;

  if (Math.abs(st - lastScrollTop) > 120) {
    const megaMenu = document.querySelector('#menu-mobile');
    if (!megaMenu) return;

    const menuItems = megaMenu.querySelectorAll('.menu-item.has-dropdown');

    menuItems.forEach((item, index) => {
      item.classList.toggle('active', index === 0);
    });

    megaMenu.querySelectorAll('.mega-dropdown').forEach(d => {
      d.classList.remove('active');
      d.style.display = 'none';
    });

    const firstDropdown = megaMenu.querySelector('.mega-dropdown[data-menu-item-index="0"]');
    if (firstDropdown) {
      firstDropdown.style.display = 'block';
      firstDropdown.classList.add('active');
    }
  }

  lastScrollTop = st <= 0 ? 0 : st;
}, false);